/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceList
 */
export interface PriceList {
    /**
     * 
     * @type {number}
     * @memberof PriceList
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PriceList
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof PriceList
     */
    validFrom: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PriceList
     */
    draft: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PriceList
     */
    active: boolean;
}

/**
 * Check if a given object implements the PriceList interface.
 */
export function instanceOfPriceList(value: object): value is PriceList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('draft' in value) || value['draft'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function PriceListFromJSON(json: any): PriceList {
    return PriceListFromJSONTyped(json, false);
}

export function PriceListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'validFrom': (new Date(json['validFrom'])),
        'draft': json['draft'],
        'active': json['active'],
    };
}

export function PriceListToJSON(json: any): PriceList {
    return PriceListToJSONTyped(json, false);
}

export function PriceListToJSONTyped(value?: PriceList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'validFrom': ((value['validFrom']).toISOString()),
        'draft': value['draft'],
        'active': value['active'],
    };
}

